// src/config.js
const AppConfig = {
    title: "title bo test",
    paragraph: "pg bo test",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Test-Logo.svg/2560px-Test-Logo.svg.png",
    url: "test",
    id: "9999999"
};

export default AppConfig;
